/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconDragonWing: {
  name: 'dragon_wing';
  data: string;
} = {
  name: 'dragon_wing',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m475.743 597.818 124.362-.893-.156-62.816c-99.13-145.843-92.779-261.039-67.333-369.037C376.129 32.262 195.728 25.676 27.806 23.735 76.105 79.343 74.36 137.781 41.944 190.56c73.365 23.485 77.542 126.079 48.068 186.62 90.575-25.484 178.783 53.532 124.411 144.205 110.148-92.6 271.348-52.342 261.316 76.434l.004-.001z"/></svg>`,
};
